export default __webpack_public_path__ + "static/media/axiatadigitallabs_logo.3ee81fbb.svg";